import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentRolesHttpClient } from './tellent-roles.http';
import { TellentRolesActions } from './tellent-roles.store';

@Injectable({ providedIn: 'root' })
export class TellentRolesEffects {
  public effects = createEffectFactory(TellentRolesActions, this.actions$);

  public fetchCollection$ = this.effects(TellentRolesActions.fetchCollection, ({ payload }) =>
    this.tellentRolesHttpClient.fetchCollection(payload!.scope).pipe(map(data => ({ data }))),
  );

  constructor(
    private tellentRolesHttpClient: TellentRolesHttpClient,
    private actions$: Actions,
  ) {}
}
